declare global {
  interface Window {
    env: {
      APP_API: string
      APP_IDENTITY: string
      APP_HUB: string
      APP_MAINTENANCE: boolean
      APP_MAINTENANCE_MESSAGE: string
      APP_AAD_ENABLED: string
      APP_AAD_AUTHORITY: string
      APP_AAD_CLIENTID: string
      APP_AAD_REDIRECTURI: string
      APP_CA_URL: string
    }
  }
}

export const host = window.env.APP_API
export const ipCheckerHost = 'https://whatismyipaddress.com/ip'
